import useApi from '@/lib/api/useApi';
import { useContext } from 'react';
import ChallengePortfolioContext from '../../../../ChallengePortfolioContext';
import useAuthenticatedUser from '@/lib/auth/useAuthenticatedUser';
import type KanbanPhase from '@/lib/constants/KanbanPhase.enum';
import { type ChallengeWithoutRelations } from '@/lib/types';

const useCreateChallenge = (): ((
  name: string,
  phase: KanbanPhase,
  rowId: number,
  modelId: number | null,
) => Promise<void>) => {
  const api = useApi();

  const [, setChallengePortfolio] = useContext(ChallengePortfolioContext);
  const authenticatedUser = useAuthenticatedUser()!;

  const createChallenge = async (
    name: string,
    phase: KanbanPhase,
    rowId: number,
    modelId: number | null,
  ): Promise<void> => {
    const challenge = await api.post<ChallengeWithoutRelations>(
      `challenge-portfolio/challenges?rowId=${rowId}${modelId !== null ? `&modelId=${modelId}` : ''}`,
      {
        name,
        phase,
      },
    );

    setChallengePortfolio(challengePortfolio => {
      challengePortfolio.challenges[challenge.id] = {
        ...challenge,
        thumbnail: null,
        users: [authenticatedUser],
        invitees: [],
        worlds: [],
        tags: [],
        tasks: [],
        _count: {
          coachComments: 0,
        },
      };

      challengePortfolio.rows[rowId].challenges.push(challenge.id);

      return challengePortfolio;
    });
  };

  return createChallenge;
};

export default useCreateChallenge;
